var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main",class:_vm.align},[_c('h4',{staticClass:"primary-title_ text-uppercase text-h4 font-weight-bold mb-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }